import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import './assets/scss/_styles.scss';
import $ from 'jquery';

createApp(App).use(router).mount('#app')
